import React from 'react';
import PropTypes from 'prop-types';
import Header from '../shared/header';
import Footer from '../shared/footer';
import LanguageDirection from '../shared/languageDirection';
import MainAppreciate from './mainAppreciate';

const Appreciate = props => (
  <div>
    <LanguageDirection locale={props.locale}>
      <Header logo={props.comment.logo} />
      {!props.displayFinalMessage && <MainAppreciate {...props} />}
      {props.displayFinalMessage && (
        <h3 className="final-appreciate">{props.translations['all-set']}</h3>
      )}
      <Footer
        translations={props.translations}
        updateLocale={props.updateLocale}
        privacyPolicyLink={props.privacyPolicyLink}
      />
    </LanguageDirection>
  </div>
);

Appreciate.propTypes = {
  translations: PropTypes.objectOf(PropTypes.string).isRequired,
  comment: PropTypes.shape({
    logo: PropTypes.string,
  }).isRequired,
  displayFinalMessage: PropTypes.bool.isRequired,
  allDoneClick: PropTypes.func,
  submitVideo: PropTypes.func,
  videoUploadSuccessful: PropTypes.bool,
  privacyPolicyLink: PropTypes.string,
  basePath: PropTypes.string,
  videoFileName: PropTypes.string,
  updateLocale: PropTypes.func,
  captureFileName: PropTypes.func,
  spinnerDisplay: PropTypes.bool,
  locale: PropTypes.string,
};

Appreciate.defaultProps = {
  allDoneClick: () => {},
  submitVideo: () => {},
  videoUploadSuccessful: false,
  privacyPolicyLink: '',
  basePath: '',
  videoFileName: '',
  updateLocale: () => {},
  captureFileName: () => {},
  spinnerDisplay: false,
  locale: '',
};

export default Appreciate;
